export { default } from './LeadershipCard';
